<template>
  <v-card 
    class="mobile-record-card clickable-card" 
    :class="{ 'row-active': active }"
    outlined 
    flat
    v-ripple
    @click="$emit('click')"
  >
    <div class="mobile-header d-flex justify-space-between align-center px-3 py-2">
      <span class="font-weight-bold white--text">{{ headerLabel }}</span>
      <v-chip dark small>{{ headerValue }}</v-chip>
    </div>

    <div class="mobile-body">
      <div 
       v-for="(field, index) in fields.filter(f => f.key !== 'imageContent')"
        :key="index"
        class="m-row px-3 py-2"
        :class="{ 'gray-bg': index % 2 !== 0 }"
      >
        <span class="m-label">{{ field.label }}</span>
        
        <div class="m-value">
          <slot :name="field.key" :value="item ? item[field.key] : ''">
            {{ item ? item[field.key] : '' }}
          </slot>
        </div>        
      </div>

      <div v-if="item && item.imageContent" class="pa-2 border-top">
        <div class="m-label mb-1">Groove Design:</div>
        <div class="d-flex justify-center bg-white rounded-lg pa-2 border">
          <v-img
            :src="item.imageContent"
            max-width="200"
            contain
            style="cursor: zoom-in;"
            class="cursor-pointer"
            @click.stop="$emit('preview', item.imageContent)"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate size="20" color="grey"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </div>
      </div>
    </div>
  </v-card>

</template>

<script>
export default {
  name: 'MobileCardItem',
  props: {
    item: { type: Object, required: true },
    active: { type: Boolean, default: false },
    headerLabel: { type: String, default: 'No' },
    headerValue: { type: [String, Number], default: '', required: true },
    // Danh sách các cột hiển thị: [{label: 'Owner', key: 'ownNm'}, ...]
    fields: { type: Array, required: true }
  }
}
</script>
<style>
/* Trong file MobileCardItem.vue hoặc file CSS chung */
.m-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start; /* Để nhãn nằm trên cùng nếu value xuống nhiều dòng */
  padding: 8px 12px;
  border-bottom: 0.5px solid rgba(128,128,128,0.1);
}

.m-label {
  font-weight: bold;
  color: #666;
  white-space: nowrap; /* Không cho nhãn xuống dòng */
  margin-right: 15px;  /* Khoảng cách an toàn với nội dung */
  min-width: 80px;     /* Độ rộng cố định tối thiểu cho nhãn */
}

.m-value {
  flex: 1;             /* Chiếm toàn bộ không gian còn lại */
  text-align: right;   /* Căn phải nội dung */
  word-break: break-word; /* Tự động xuống dòng khi gặp từ dài */
  font-size: 0.9rem;
  line-height: 1.4;
  display: flex;
  justify-content: flex-end; /* Căn nội dung sang phải */
  align-items: center;      /* Căn giữa icon và chữ theo chiều dọc */
}

.m-row-special {
  padding: 10px;
  background: #f9f9f9;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: center; /* Căn giữa hình vẽ */
}

/* Đảm bảo icon không bị dính sát vào chữ */
.m-value .v-icon {
  margin-right: 4px;
  cursor: pointer;
}
</style>